import { useCallback, useEffect, useState } from 'react';

import { ChatMessageActionProvider } from '../../entities/chat-message-action';
import { fetchIntegrations } from '../api/integration';
import { fetchLinkedAccounts } from '../api/notifications';

// Backs the "already connected" grey-out on persisted connect_integration chat actions
// (integration-agent-contract.md §3 "Reflecting already connected") — actions are static once
// persisted, so this refetches on mount and on window focus (the OAuth tab opens separately)
// rather than trusting whatever was true when the message was sent.
export function useConnectedIntegrations(): Record<ChatMessageActionProvider, boolean> {
  const [isConnected, setIsConnected] = useState<Record<ChatMessageActionProvider, boolean>>({
    jira: false,
    trello: false,
    slack: false,
    telegram: false,
  });

  const refresh = useCallback(() => {
    fetchIntegrations()
      .then((d) => setIsConnected((prev) => ({ ...prev, jira: !!d?.isJiraConnected, trello: !!d?.isTrelloConnected })))
      .catch(() => {});
    fetchLinkedAccounts()
      .then((accounts) =>
        setIsConnected((prev) => ({
          ...prev,
          slack: accounts.some((a) => a.channel === 'slack'),
          telegram: accounts.some((a) => a.channel === 'telegram'),
        })),
      )
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);

  return isConnected;
}
